import { ArsTableCellType, ArsTableDataCell } from "../interface";
import { isArsTableCellBase } from "./isArsTableCellBase";

/**
 * Type guard for ArsTableDataCell, which is a possible type of ArsTableCellBase.
 *
 * @param obj - The object to check
 * @param isT - A type guard function for the generic type T used in the cell's displayContent and annotationContent
 * @returns - True if the object is an ArsTableDataCell, false otherwise
 */
export const isArsTableDataCell = <T = string>(
  obj: unknown,
  isT: (value: unknown) => value is T,
): obj is ArsTableDataCell<T> => {
  if (!isArsTableCellBase<T>(obj, isT)) return false;

  if (obj.cellType !== ArsTableCellType.DataCell) return false;

  // Everything is good
  return true;
};
